// src/components/home/HomeValuePropositionSection.js
import React from 'react';
// Imports Swiper
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay, A11y } from 'swiper/modules';

// Styles Swiper
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';

import './HomeValuePropositionSection.css'; // Nouveau fichier CSS

const homeValuePoints = [ // Renommé pour éviter les conflits
  {
    id: 'hvp1',
    icon: '✨', // Icône différente
    title: "Expertise Locale, Portée Globale",
    description: "Basés à Lombez, nous comprenons les enjeux locaux tout en offrant des solutions web de pointe, capables de rivaliser sur le marché global."
  },
  {
    id: 'hvp2',
    icon: '🚀', // Icône différente
    title: "Développement Agnostique",
    description: "Que vous ayez besoin d'un site vitrine, d'une boutique e-commerce ou d'une application complexe, nous choisissons les technologies les plus adaptées à vos objectifs."
  },
  {
    id: 'hvp3',
    icon: '📈', // Icône différente
    title: "Orienté Résultat & ROI",
    description: "Chaque projet est conçu avec un objectif clair : maximiser votre visibilité en ligne, optimiser vos conversions et générer un retour sur investissement tangible."
  },
  {
    id: 'hvp4',
    icon: '🌍', // Icône différente
    title: "Design UX/UI Intuitif",
    description: "Nous créons des interfaces non seulement esthétiques mais aussi intuitives et performantes, assurant une expérience utilisateur optimale sur tous les appareils."
  },
  // AJOUT DES POINTS DE VALEUR DE LA SECTION PRÉCÉDENTE
  {
    id: 'hvp5', // ID unique
    icon: '💡',
    title: "Solutions Innovantes & Sur Mesure",
    description: "Nous ne nous contentons pas de suivre les tendances, nous créons des solutions web personnalisées qui répondent précisément à vos enjeux et anticipent vos besoins futurs."
  },
  {
    id: 'hvp6', // ID unique
    icon: '🤝',
    title: "Approche Collaborative Transparente",
    description: "Votre projet est notre projet. Nous travaillons en étroite collaboration avec vous à chaque étape, en assurant une communication claire et régulière."
  },
  {
    id: 'hvp7', // ID unique
    icon: '🛠️',
    title: "Expertise Full-Stack Polyvalente",
    description: "De la conception UX/UI au développement backend complexe et au déploiement, notre équipe maîtrise l'ensemble de la chaîne de production web."
  },
  {
    id: 'hvp8', // ID unique
    icon: '🌟',
    title: "Engagement Qualité & Support",
    description: "Nous nous engageons à livrer des produits de haute qualité, testés rigoureusement, et à vous fournir un support réactif pour assurer votre satisfaction à long terme."
  }
];

function HomeValuePropositionSection() { // Renommé la fonction
  return (
    <section className="home-value-proposition-section"> {/* Nouvelle classe */}
      <h2 className="section-title">Ce qui nous distingue</h2> {/* Nouveau titre */}

      <Swiper
        modules={[Navigation, Pagination, Autoplay, A11y]}
        spaceBetween={30}
        slidesPerView={1}
        loop={homeValuePoints.length > 1} // Changé pour homeValuePoints
        centeredSlides={false}
        grabCursor={true}
        autoplay={{
          delay: 4500,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        pagination={{
          clickable: true,
          dynamicBullets: false,
          el: '.home-value-proposition-swiper-pagination' // Nouvelle classe
        }}
        navigation={{
          nextEl: '.home-value-proposition-swiper-button-next', // Nouvelle classe
          prevEl: '.home-value-proposition-swiper-button-prev', // Nouvelle classe
        }}
        className="home-value-points-swiper" // Nouvelle classe
        breakpoints={{
          768: {
            slidesPerView: 2,
            spaceBetween: 25,
            centeredSlides: homeValuePoints.length > 2, // Changé pour homeValuePoints
          },
          1024: {
            slidesPerView: homeValuePoints.length >= 3 ? 3 : homeValuePoints.length, // Changé pour homeValuePoints
            spaceBetween: 30,
            centeredSlides: homeValuePoints.length > 3, // Changé pour homeValuePoints
          },
        }}
      >
        {homeValuePoints.map(point => ( // Changé pour homeValuePoints
          <SwiperSlide key={point.id} className="home-value-point-swiper-slide"> {/* Nouvelle classe */}
            <div className="home-value-point-card"> {/* Nouvelle classe */}
              <div className="home-value-point-icon-wrapper"> {/* Nouvelle classe */}
                <span className="home-value-point-icon" role="img" aria-label="">{point.icon}</span> {/* Nouvelle classe */}
              </div>
              <div className="home-value-point-content"> {/* Nouvelle classe */}
                <h3>{point.title}</h3>
                <p>{point.description}</p>
              </div>
            </div>
          </SwiperSlide>
        ))}
        <div className="swiper-custom-controls-home-vp"> {/* Nouvelle classe */}
          <div className="home-value-proposition-swiper-button-prev swiper-nav-button-home-vp" aria-label="Point précédent"> {/* Nouvelle classe */}
            ❮
          </div>
          <div className="home-value-proposition-swiper-pagination swiper-custom-pagination-home-vp"></div> {/* Nouvelle classe */}
          <div className="home-value-proposition-swiper-button-next swiper-nav-button-home-vp" aria-label="Point suivant"> {/* Nouvelle classe */}
            ❯
          </div>
        </div>
      </Swiper>
    </section>
  );
}

export default HomeValuePropositionSection;